// Browser (desktop) notification permission helpers. The permission is global to
// the origin, so it's requested once at the pre-game gate (PermissionsDialog),
// then read by the chat panel before it shows anything.

export function notificationsSupported(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window
}

/** Whether we're actually allowed to show a notification right now. */
export function canNotify(): boolean {
  return notificationsSupported() && Notification.permission === 'granted'
}

/**
 * Prompt for notification permission, but only when it hasn't been decided yet —
 * a user who already granted or denied is never re-prompted. Safe to call from a
 * user gesture (e.g. the Join click); errors are swallowed so it never blocks the
 * caller.
 */
export async function requestNotificationPermission(): Promise<void> {
  if (!notificationsSupported() || Notification.permission !== 'default') return
  try {
    await Notification.requestPermission()
  } catch {
    /* ignore — some browsers reject rather than resolve when blocked */
  }
}
